export const seyahatOzelPage = () => `
  <section class="page-content service-page">
    <div class="container">
      <div class="service-header">
        <h1 class="page-title">Seyahat ve Özel Sigortalar</h1>
        <p class="page-subtitle">Yurt içi ve yurt dışı seyahatlerinizde sağlık güvencesi ve özel sigorta çözümleri sunuyoruz.</p>
      </div>

      <div class="service-list">
        <div class="service-item">
          <div class="service-icon">
            <img src="/icons/seyahat_saglık.png" alt="Seyahat Sağlık">
          </div>
          <div class="service-info">
            <h3>Seyahat Sağlık Sigortası</h3>
            <p>Yurt dışı seyahatlerinizde sağlık giderlerinizi karşılayan zorunlu sigorta. Vize başvuruları için geçerli olan Schengen ülkeleri dahil tüm dünyada geçerli poliçeler sunuyoruz.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Yurt Dışı Sigortaları</h3>
            <p>Uzun süreli yurt dışı ikamet, çalışma veya eğitim amaçlı kapsamlı sağlık sigortası. Bagaj kaybı, uçuş iptali ve kişisel sorumluluk teminatları da eklenebilir.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Eğitim Sigortaları</h3>
            <p>Çocuğunuzun eğitim geleceğini güvence altına alın. Eğitim sigortası ile belirlenen süre sonunda birikim yaparak eğitim masraflarını karşılayabilirsiniz.</p>
          </div>
        </div>
      </div>

      <div class="service-cta">
        <h2>Seyahatiniz İçin Teklif Alın</h2>
        <p>Vize başvurusu, tatil veya iş seyahati — ihtiyacınıza uygun seyahat sigortası bulalım.</p>
        <a href="/teklif-al" class="btn-primary">Hemen Teklif Al</a>
      </div>
    </div>
  </section>
`;
